import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, EventEmitter, Output, inject, signal } from '@angular/core';
import { DivisionViewModel, GameDetailsViewModel } from '../../../shared/models/GameModels';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { GameService } from '../../../shared/services/game.service';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDivider, MatDividerModule } from "@angular/material/divider";
import { MatDialog } from '@angular/material/dialog';
import { MatAnchor, MatButtonModule } from "@angular/material/button";
import { RouterModule } from "@angular/router";
import { SetGradesDialogComponent } from '../../screens/set-grades-dialog/set-grades-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-game-header-full',
  imports: [CommonModule, MatSnackBarModule, MatIconModule, MatProgressBarModule, MatProgressSpinnerModule, MatDividerModule, MatAnchor, MatButtonModule, RouterModule, TranslatePipe],
    templateUrl: './game-header-full.component.html',
    styleUrls: ['./game-header-full.component.css']
})
export class GameHeaderFullComponent implements OnInit {

  @Input() GameDetails: GameDetailsViewModel;        
  @Input() Division: DivisionViewModel;
  @Output() onStatisticsUpdated = new EventEmitter();

  isLoadingStats = signal(false);
  showDetailedStats: boolean = true;
  private _snackBar = inject(MatSnackBar);
  private _gameService = inject(GameService);
  private _dialog = inject(MatDialog);
 
  constructor() { }

  ngOnInit() {
    this.GameDetails = this.GameDetails || { Game: { HomeTeamSmallIcon: '', AwayTeamSmallIcon: '', GameDate: '', GameTime: '', Venue: '' }, AwayTeam: { Name: '' }, HomeTeam: { Name: '' }, Division: { Name: '' } };
    this.Division = this.Division || { Name: '' };
  }

  importStats() {
    this.isLoadingStats.set(true);
    this._gameService.getExternalGameStatistics(this.GameDetails.Game.GameId).pipe(finalize(() => this.isLoadingStats.set(false))).subscribe({
      next: data => {
        if (data.success)
          this.onStatisticsUpdated.emit();
        else
          this.openSnackBar(data.errormessage, "Close", 3000);
      },
      error: () => this.openSnackBar("Failed to import statistics", "Close", 3000)
    });
  }
  getIconPath(icon: string): string {

    icon = icon.toLowerCase();
    if (icon.startsWith('/')) {
      return `../assets/img${icon}`;
    } else {
      return `../assets/img/${icon}`;
    }
  }
  

  handleImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = '../assets/img/placeholder.png';
    imgElement.style.width = '30px';
    imgElement.style.height = '30px';
    imgElement.style.objectFit = 'contain';
  }

  toggleDetailedStats() {
    this.showDetailedStats = !this.showDetailedStats;
  }

  openSnackBar(message: string, action: string, duration: number) {
    this._snackBar.open(message, action, {
      duration: duration
    });
  }

      openSetGradesDialog(players: 'home' | 'away') {
        const dialogRef = this._dialog.open(SetGradesDialogComponent, {
          width: '100vw',
          maxWidth: '450px',
          height: '100dvh',
          maxHeight: '100dvh',
          panelClass: 'side-dialog',
          position: {
            right: '0'
          },
          data: {
            players: players === 'home' ? this.GameDetails.HomeTeam.Players : this.GameDetails.AwayTeam.Players,
            game: this.GameDetails.Game,
            team: players
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          // console.log(`Dialog result: ${result}`);
        });
      }

}
